/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_TitleInputs */

const cs_tasks_title = /** @type {(inputs: Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkoly`)
};

const en_tasks_title = /** @type {(inputs: Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Tasks_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_title = /** @type {((inputs?: Tasks_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_title(inputs)
	return cs_tasks_title(inputs)
});